import { ConfirmActionDialog } from '../Widgets/ConfirmActionDialog';

interface ConfirmationModalProps {
  visible: boolean;
  title?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  /** A less common way to resolve the dialog — rendered as a de-emphasized link. */
  alternateLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  onAlternate?: () => void;
}

export const ConfirmationModal = ({
  visible,
  title,
  message,
  confirmLabel = 'OK',
  cancelLabel = 'Cancel',
  alternateLabel,
  onConfirm,
  onCancel,
  onAlternate,
}: ConfirmationModalProps) => {
  if (!visible) return null;

  return (
    <ConfirmActionDialog
      title={title ?? 'Confirm action'}
      message={message ?? ''}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      alternateLabel={alternateLabel}
      onConfirm={onConfirm}
      onCancel={onCancel}
      onAlternate={onAlternate}
    />
  );
};
